import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalStorageService } from 'ngx-webstorage';
import { LazyLoadEvent, MenuItem } from 'primeng/api';
import { CountryService } from '../../../services';
import { IGlobalSearchParam } from '../../../../shared/models/Global-Search.model';

import {DialogService} from 'primeng/dynamicdialog';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import { Message } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { CountryViewModalComponent } from '../..';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Country } from 'src/app/admin/models/country.model';
import { Table } from 'primeng/table';
import { SelectItem, FilterService, FilterMatchMode } from "primeng/api";
import { ExcelService } from 'src/app/shared/services/excel.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as fs from 'file-saver';

@Component({
  selector: 'app-country-search',
  templateUrl: './country-search.component.html',
  styleUrls: ['./country-search.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService, ConfirmationService, MessageService]
})
export class CountrySearchComponent implements OnInit {
  //currentUser;
  showTopFilters: boolean;
  showFilters:boolean;
  showSorting:boolean;
  matchModeOptions: SelectItem[];
  matchModeOptionsForDate: SelectItem[];
  matchModeOptionsForNumeric: SelectItem[];
  showAddRuleButton:boolean = false;
  oldSortField:string = 'createdOn';
  oldSortOrder:string = 'desc';
  sortField:string = 'createdOn';
  sortOrder:string = 'desc';
  appliedFilters:{field:string,matchMode:string,value:string}[]=[];
  pageNo: number =1;
  pageSize: number =10;
  oldPageNo: number =1;
  oldPageSize: number =10;
  totalRecords: number;
  loadEvent: LazyLoadEvent;
  filters;
  filterCondition: { fieldName: string; type: string; }[] =[];
  startSearch: boolean = false;
  countryList;
  gridSpinner = 'gridSpinner1';
  isSearchLoading: boolean = false;
  loading: boolean = false;
  countrySearchParam:IGlobalSearchParam;
  items: MenuItem[];
  countrySearchSpinner = 'countrySearchSpinner';
  ref: DynamicDialogRef;
  msgs: Message[] = [];
  dialogPosition = 'topright';
  isCountryAdd : boolean = false;
  isCountryEdit : boolean = false;
  buttonLabel: string = "";
  title: string = "";
  countryForm:FormGroup;
  selectedGridMenuItem:any = null;
  showToggle:boolean;
  isshowpaginator:boolean=true;
  statusValues:any;
  selectedStatusId:any="All";
  selectedStatus:any;

  allColumns = [
    { value: 'action', header: 'Action' },
    { value: 'countryName', header: 'Country Name' },
    { value: 'countryCode', header: 'Country Code' },
    { value: 'isActive', header: 'Is Active' },
    { value: 'createdBy', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' }
  ]

  selectedColumns = [
    { value: 'action', header: 'Action' },
    { value: 'countryName', header: 'Country Name' },
    { value: 'countryCode', header: 'Country Code' },
    { value: 'isActive', header: 'Is Active' },
    { value: 'createdBy', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' }
  ]
  @ViewChild('dt2', { static: true }) table: any;

  constructor(
    public datepipe: DatePipe,
   // private storage: LocalStorageService,
    private spinner: NgxSpinnerService,
    private countryService:CountryService,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private primengConfig: PrimeNGConfig,
    private _fb: FormBuilder,
    private excelService:ExcelService,
    public sharedService:SharedService,
    private _router: Router
  ) 
  {
    this.showFilters = false;
    this.showSorting = false;
    this.spinner.show();
    setTimeout(() => {
        this.spinner.hide();
    }, 1000);
    /*this.items = [
     
      {
       label:'Edit',
       icon:'pi pi-fw pi-pencil',
       command: e => this.editCountryDetails(this.selectedGridMenuItem.countryId)
      },
      {
       label:'Delete',
       icon:'pi pi-fw pi-trash',
       command: e => this.deleteConfirm(this.selectedGridMenuItem.countryId)
      }
   ];*/
    //this.currentUser = this.storage.retrieve('currentuser');
    
   
  }

  ngOnInit(): void {
    this.checkViewPermission();
    this.items = [];
    this.checkEditDeletePermission();
    const customFilterName = "custom-equals";
    const notEquals = "not-equals";
    const dateAfter = "date-after";
    const dateBefore = "date-before";
    
    this.matchModeOptions = [
      { label: "Custom Equals", value: customFilterName },
      { label: "Starts With", value: FilterMatchMode.STARTS_WITH },
      { label: "Contains", value: FilterMatchMode.CONTAINS }
    ];

    this.matchModeOptionsForDate = [
      { label: "Equals", value: customFilterName },
      { label: "Not Equals", value: notEquals },
      { label: "Greater Than", value: dateAfter },
      { label: "Less Than", value: dateBefore },
    ];

    this.matchModeOptionsForNumeric = [
      { label: "Custom Equals", value: customFilterName },
      { label: "Greater than or equal to", value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
      { label: "Less than or equal to", value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
    ];

    this.filterCondition=[
      {fieldName:"countryName",type:"basic"},
      {fieldName:"countryCode",type:"basic"},
      {fieldName:"isActive",type:"basic"},
      {fieldName:"createdBy",type:"basic"},
      {fieldName:"createdOn",type:"date"},
    ];
    this.appliedFilters.push({ field:"globalfilter", matchMode:"equals", value:"0" }) 
    this.getCountryList();
    this.statusValues=['All','Active',"Inactive"];
    this.InitialSetup();
  }
  checkViewPermission()
  {
    var result = this.sharedService.checkPermission("Admin_View");
    if(!result)
    this._router.navigateByUrl('/login');
  }
  InitialSetup(){
    this.countryForm = this._fb.group({
      countryId: new FormControl(0,[Validators.required]),
      continentId: new FormControl(0),
      countryName: new FormControl("",[Validators.required]),
      countryCode: new FormControl("",[Validators.required]),
      isActive: new FormControl(false,[Validators.required]),
      createdBy: new FormControl(""),
      createdOn: new FormControl(""),
      modifiedBy: new FormControl(""),
      modifiedOn: new FormControl("")
    })
  }
  
  getCountryList()
  {
    this.countrySearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         sortOrder:this.sortOrder
       };
       this.spinner.show(this.countrySearchSpinner);
    this.countryService.getAllCountries(this.countrySearchParam).subscribe((data: any) => {
      this.appliedFilters = [];
      this.countryList =data;
      this.isshowpaginator=this.countryList.length>0?true:false;
      console.log(this.countryList);
      this.totalRecords = data[0].totalCount;
      this.spinner.hide(this.countrySearchSpinner);
     });
  }


  loadCountryList(event:LazyLoadEvent)
  { 
    this.loadEvent=event;
    if(event.first==0)
    {
      this.pageNo = 1;
    }
    else {
      this.pageNo=(event.first/event.rows)+1;
    }
    this.pageSize=event.rows;
    
    this.pageSize=event.rows;
    
    if((this.oldPageNo != this.pageNo) || (this.oldPageSize != this.pageSize))
    {
      this.applyFilter();
      this.getCountryList();
    }
    this.oldPageNo = this.pageNo;
    this.oldPageSize = this.pageSize;
    this.filters=event.filters;
    if(this.filters["createdOn"]!= undefined)
    {
    if(this.filters["createdOn"][0].matchMode == "date-after")
    {
       this.showAddRuleButton = true;
    }
    else{
      this.showAddRuleButton = false;
    }
    }
    this.sortField=event.sortField;
    if(event.sortField === undefined || event.sortField === null)
    {
      this.sortField='createdOn';
    }
    if(event.sortOrder === 1)
    {
    this.sortOrder='desc';
    }
    if(event.sortOrder === -1)
    {
    this.sortOrder='asc';
    }
    /*if(this.sortField !== 'createdOn')
    {
      this.getCountryList()
    }*/

    if(this.oldSortField !==  this.sortField ||  this.oldSortOrder !== this.sortOrder)
    {
      this.applyFilter();
      this.getCountryList()
    }
    this.oldSortField = this.sortField;
    this.oldSortOrder = this.sortOrder;
  }


  search()
  {
    console.log(this.filterCondition.length);
    for(let i=0;i<this.filterCondition.length;i++)
    {
      if(this.filterCondition[i].type == "checkbox")
      {
        if(this.filters[this.filterCondition[i].fieldName].value == true)
        {
          this.appliedFilters.push({field:this.filterCondition[i].fieldName,matchMode:this.filters[this.filterCondition[i].fieldName].matchMode ,value:"true"}) 
        }
        else if (this.filters[this.filterCondition[i].fieldName].value == false){
          this.appliedFilters.push({field:this.filterCondition[i].fieldName,matchMode:this.filters[this.filterCondition[i].fieldName].matchMode ,value:"false"}) 
        }
      }
      else {
        this.appliedFilters.push({field:this.filterCondition[i].fieldName,matchMode:this.filters[this.filterCondition[i].fieldName].matchMode ,value:this.filters[this.filterCondition[i].fieldName].value}) 
      }
      if(i==this.filterCondition.length-1 )
      {
        this.startSearch = true; 
      } 
    }
    if(this.startSearch == true)
    {
      this.countrySearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         sortOrder:this.sortOrder
       };
       this.spinner.show(this.countrySearchSpinner);
      this.countryService.getAllCountries(this.countrySearchParam).subscribe((data: any) => {
        this.appliedFilters = [];
        this.countryList =data;
        this.isshowpaginator=this.countryList.length>0?true:false;
        console.log(this.countryList);
        this.totalRecords = data[0].totalCount;
        this.spinner.hide(this.countrySearchSpinner);
       });
    }
  }




  showCountryDetails(paramId: number)
  {
    this.ref = this.dialogService.open(CountryViewModalComponent, {
      header: 'Country Details',
      width: '50%',
      contentStyle: {"max-height": "500px", "overflow": "auto"},
      baseZIndex: 10000,
      data: {id: paramId}
  });
  }




  deleteConfirm(paramId:number) {
    this.dialogPosition = 'topright';
    console.log('deleteConfirm deleteConfirm ');
    this.confirmationService.confirm({
      message: 'Do you want to delete this country?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        console.log("hi");
        this.countryService.deleteCountryDetail(paramId).subscribe((data: any) => {
          this.getCountryList();
          this.messageService.add({severity:'info', summary:'Confirmed', detail:'You have deleted the record'});
         });
      },
      reject: (type) => {
        switch(type) {
            case ConfirmEventType.REJECT:
                this.messageService.add({severity:'error', summary:'Rejected', detail:'You have rejected'});
            break;
            case ConfirmEventType.CANCEL:
                this.messageService.add({severity:'warn', summary:'Cancelled', detail:'You have cancelled'});
            break;
        }
      },
      key: "positionDialog"
    });
  }

  addCountryDetails(){
    this.InitialSetup();
    this.isCountryAdd = true;
    this.isCountryEdit = false;
    this.title = "Country Add";
    this.buttonLabel = "Save";
  }

  editCountryDetails(paramId: number)
  { 
    this.InitialSetup();
    this.isCountryEdit = true;
    this.isCountryAdd = false;
    this.title = "Country Edit";
    this.buttonLabel = "Update";
    this.countryService.getCountryDetail(paramId).subscribe((data:Country) =>{
      this.countryForm.patchValue(data);
    },error => {
      console.log(error)
    })
  }

  cancel(){
    this.isCountryAdd = false;
    this.isCountryEdit = false;
  }

  save({value}: {value: Country}){
    console.log(value);
    if(value.countryId == 0){
      value.createdBy = 1;
      value.createdOn = new Date();
      this.countryService.postCountryDetail(value).subscribe(data => {
        this.getCountryList();
        this.isCountryAdd = false;
      }, error => {
        console.log(error)
      })
    }else{
      this.countryService.updateCountryDetail(value.countryId, value).subscribe(data => {
        this.getCountryList();
        this.isCountryEdit = false;
      }, error => {
        console.log(error);
      })
    }
  }

  clearFilter(table: Table) {
    for (let i = 0; i < this.filterCondition.length; i++) {
      if (this.table.filters[this.filterCondition[i].fieldName] != undefined) {
       this.table.filters[this.filterCondition[i].fieldName][0].value = null;
      }
    }
    table.clear();
    this.appliedFilters = [];
    this.selectedStatusId = [];
    this.selectedStatus= [];
    // this.applyFilter();
    this.getCountryList();
  }
  
  bindShowFilter() {
    this.showFilters = (this.showFilters ? false : true)
  }

  bindShowSorting() {
    this.showSorting = (this.showSorting ? false : true)
  }

  bindShowTopFilter() {
    this.showTopFilters = (this.showTopFilters ? false : true)
  }

  applyFilterNew(table: Table){
    this.filters=table.filters;
    this.applyFilter();
  }

  applyFilter()
  {
    console.log(this.filterCondition.length);
    console.log(this.filterCondition);
    console.log(this.filters);
    if (Object.keys(this.filters).length > 1) {
      this.appliedFilters = [];
      for (let i = 0; i < this.filterCondition.length; i++) {
        if (this.filterCondition[i].type == "checkbox") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value == true) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: "true"
              })
            }
            else if (this.filters[this.filterCondition[i].fieldName][0].value == false) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: "false"
              })
            }
          }
        }
        else if (this.filterCondition[i].type == "basic") {
          console.log("filter type is basic");
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
              console.log("filter field name is "+[this.filterCondition[i].fieldName][0]);
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
            }
          }
        }
        else if (this.filterCondition[i].type == "date") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            for (let j = 0; j <= this.filters[this.filterCondition[i].fieldName].length - 1; j++) {
              if (this.filters[this.filterCondition[i].fieldName][j].value !== null)
                this.appliedFilters.push({
                  field: this.filterCondition[i].fieldName,
                  matchMode: this.filters[this.filterCondition[i].fieldName][j].matchMode,
                  value: this.datepipe.transform(this.filters[this.filterCondition[i].fieldName][j].value,"MM-dd-yyyy")
                })
            }
          }
        }
        else if (this.filterCondition[i].type == "numeric") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null)
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
          }
        }
    }
    }

    if(this.startSearch == true || this.startSearch == false)
    {
      this.countrySearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         //searchGlobalFilter: this.searchGlobalFilter,
         sortOrder:this.sortOrder
       };
      this.spinner.show(this.countrySearchSpinner);
      this.countryService.getAllCountries(this.countrySearchParam).subscribe((data: any) => {
      this.countryList =data;
      this.isshowpaginator=this.countryList.length>0?true:false;
      console.log(this.countryList);
      this.totalRecords = data[0].totalCount;
      this.spinner.hide(this.countrySearchSpinner);
      });
    }
  }

  exportExcel() {
    let header = ['Country Name', 'Country Code', 'Is Active', 'Created By', 'Created On'];
    let jsonKey = ['countryName', 'countryCode', 'isActive', 'createdByUser', 'createdOn'];
    let data = this.countryList;
    var arrFinalData = [];
    var columnsKeyNames = [];
    for (var i = 0; i < data.length; i++) {
      var singleRow_temp = data[i];
      columnsKeyNames = Object.keys(singleRow_temp);
      var column0_temp = "";
      var column1_temp = "";
      var column2_temp = "";
      var column3_temp = "";
      var column4_temp = "";
      for (var j = 0; j < columnsKeyNames.length; j++) {
        if (columnsKeyNames[j] == jsonKey[0]) {
          column0_temp = singleRow_temp[columnsKeyNames[j]];
        }
        if (columnsKeyNames[j] == jsonKey[1]) {
          column1_temp = singleRow_temp[columnsKeyNames[j]];
        }
        if (columnsKeyNames[j] == jsonKey[2]) {
          if(singleRow_temp[columnsKeyNames[j]] == true){
            column2_temp = 'ACTIVE';
          }
          if(singleRow_temp[columnsKeyNames[j]] == false){
            column2_temp = 'INACTIVE';
          }
        }
        if (columnsKeyNames[j] == jsonKey[3]) {
          column3_temp = singleRow_temp[columnsKeyNames[j]].firstName;
        }
        if (columnsKeyNames[j] == jsonKey[4]) {
          column4_temp = this.datepipe.transform(singleRow_temp[columnsKeyNames[j]],'MM/dd/yyyy');
        }
      }
      arrFinalData.push([column0_temp,column1_temp,column2_temp,column3_temp,column4_temp])
    }
    this.excelService.exportExcel(header,arrFinalData,'country-search')
  }

  bindShowToggle() {
    this.showToggle = (this.showToggle ? false : true)
  }

  showAndHideColumn(event){
    this.selectedColumns = event.value;
  }

  isShowColumns(columnName){
    var tempColumn = this.selectedColumns.filter(col => col.value == columnName);
    if(tempColumn.length == 1){
      return true;
    }
    return false;
  }

  checkEditDeletePermission() {
    var isAdminAdd = this.sharedService.checkPermission("Admin_Add");
    var isAdminDelete = this.sharedService.checkPermission("Admin_Delete");
    if (isAdminAdd) {
      var editItem = {
        label:'Edit',
        icon:'pi pi-fw pi-pencil',
        command: e => this.editCountryDetails(this.selectedGridMenuItem.countryId)
      }
      this.items.push(editItem)
    }
    if(isAdminDelete){
      var deleteItem =  {
        label:'Delete',
        icon:'pi pi-fw pi-trash',
        command: e => this.deleteConfirm(this.selectedGridMenuItem.countryId)
       }
       this.items.push(deleteItem);
    }
  }

 getStatusOnChange(event)
 {
  this.selectedStatusId = event.value;
  this.selectedStatus=event.value;
 }

 clearStatus()
 {
  this.selectedStatus ="";
  this.selectedStatusId = undefined;
 }

 exportCountryExcel() {
  this.applyFilter();
  this.countrySearchParam = 
  {
    pageNo:this.pageNo,
    pageSize:this.pageSize,
    sortField:this.sortField,
    appliedFilters:this.appliedFilters,
    sortOrder:this.sortOrder
  };
  this.countryService.ExportCountry(this.countrySearchParam).subscribe(res => {
  var blob = new Blob([res.body], { type: res.body.type });
  const file = new File([blob],"Country.xlsx", { type: res.body.type });
  fs.saveAs(file);
  });
}
  
}
